import React from "react";
import { filterClass } from "../../utils/class-utils";
import { getTextAlignClass } from "../utils/content-alignment";
import type { HeadingBlockProps } from "../types";

export function HeadingBlock(props: HeadingBlockProps) {
  const {
    text = "Heading: Edit text in the options panel.",
    level = "h2",
    textClass = "no-class",
    fsClass = "no-class",
    ffClass = "no-class",
    fwClass = "no-class",
    alignClass = "no-class",
    paddingClass = "py-0",
    inheritedContentAlign,
    className,
  } = props;

  const resolvedAlignClass = filterClass(alignClass) || getTextAlignClass(inheritedContentAlign);

  /**
   * ===== FRONTEND: CLASSES & STRUCTURE (EDIT HERE) =====
   * This component only renders headings (h1–h6).
   */
  const resolvedClassName = [
    filterClass(textClass),
    filterClass(fsClass),
    filterClass(ffClass),
    filterClass(fwClass),
    resolvedAlignClass,
    filterClass(paddingClass),
    className,
  ]
    .filter(Boolean)
    .join(" ");

  const Tag = level as keyof React.JSX.IntrinsicElements;

  return (
    <Tag
      className={resolvedClassName || undefined}
    >
      {text}
    </Tag>
  );
}

export default HeadingBlock;


